export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deleteStaff.vue?vue&type=template&id=608952ba&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/deleteStaff.vue?vue&type=template&id=608952ba&
// module id = 1360
// module chunks = 0